import React from 'react';
import { Input } from '../ui/Input';
import { CONTENT_SEATS, EXPERIENCE_LEVELS } from '../../data/careers';
import type { StepProps } from '../../types/careers';
interface StepWorkProps extends StepProps {
  resumeFile: File | null;
  onResumeChange: (file: File | null) => void;
}
export function StepWork({
  form,
  errors,
  onChange,
  resumeFile,
  onResumeChange
}: StepWorkProps) {
  const showInstagramHelper = CONTENT_SEATS.includes(form.primarySeat);
  return <div className="space-y-6" data-id="element-75" data-mp="37ium916nlpia">
      <Input label="Years doing this kind of work" name="yearsExperience" as="select" value={form.yearsExperience} error={errors.yearsExperience} onChange={e => onChange('yearsExperience', e.target.value)} options={EXPERIENCE_LEVELS} data-id="element-76" data-mp="37j4g4zutkgt9" />

      <div className="flex flex-col space-y-2" data-id="element-77" data-mp="1h65fcshg9ztk">
        <label htmlFor="resume" className="text-sm font-medium text-engage-gray5" data-id="element-78" data-mp="1h8jcd6voxm3r">
          Resume (PDF)
        </label>
        <input id="resume" name="resume" type="file" accept=".pdf" onChange={e => onResumeChange(e.target.files?.[0] ?? null)} className={`w-full bg-engage-gray2 border rounded-sm px-4 py-2.5 text-engage-white file:mr-4 file:py-2 file:px-4 file:rounded-sm file:border-0 file:text-sm file:font-semibold file:bg-engage-yellow file:text-engage-black hover:file:bg-engage-yellow-hover cursor-pointer transition-colors duration-200 ${errors.resume ? 'border-red-500' : 'border-engage-gray3'}`} data-id="element-79" data-mp="15e83hs8ueap7" />
        {resumeFile && !errors.resume && <span className="text-xs text-engage-gray4" data-id="element-80" data-mp="1x5e4sc0aueg2">
            Attached: {resumeFile.name}
          </span>}
        {errors.resume && <span className="text-sm text-red-500" data-id="element-81" data-mp="273twag38npq3">{errors.resume}</span>}
      </div>

      <div className="flex flex-col space-y-2" data-id="element-82" data-mp="225ioeawi7pai">
        <Input label="Instagram profile (optional)" name="portfolioUrl" placeholder="@janesmith or https://instagram.com/janesmith" value={form.portfolioUrl} onChange={e => onChange('portfolioUrl', e.target.value)} data-id="element-83" data-mp="226tskbtv2z25" />
        {showInstagramHelper && <span className="text-sm text-engage-gray4" data-id="element-84" data-mp="18r7qygklne7a">
            If you've made content you're proud of, this is where we look.
          </span>}
      </div>
    </div>;
}